module.exports = __webpack_public_path__ + "img/calculator.d2529a4b.svg";